import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min';
import RoutePath from './components/RoutePath';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import LandingPageQR from './pages/certificate/LandingPageQR';
import GlobalSetting from './pages/Setting';
import FamilyName from './pages/FamilyName'
import ChangePassword from './pages/ChangePassword';
import ResetPassword from './pages/auth/ResetPassword';
import './components/axios/interceptor.js'

const Section = lazy(() => import('./pages/section/SectionRoute'));
const KambingRoute = lazy(() => import('./pages/kambing/KambingRoute'));
const DeadRoute = lazy(() => import('./pages/dead/DeadRoute'));
const Country = lazy(() => import('./pages/country/CountryRoute'));
const Vendor = lazy(() => import('./pages/vendor/VendorRoute'));
const Feeding = lazy(() => import('./pages/foods/feeding/FeedingRoute'));
const Food = lazy(() => import('./pages/foods/food/FoodRoute'));
const Bunker = lazy(() => import('./pages/foods/bunker/BunkerRoute'));
const Color = lazy(() => import('./pages/color/ColorRoute'));
const GoatPen = lazy(() => import('./pages/goat-pen/GoatPenRoute'));
const GoatType = lazy(() => import('./pages/goat-type/GoatTypeRoute'));
const Grade = lazy(() => import('./pages/grade/GradeRoute'));
const Supplier = lazy(() => import('./pages/supplier/SupplierRoute'));
const Owner = lazy(() => import('./pages/owner/OwnerRoute'));
const MatingPreparationRoute = lazy(() => import('./pages/mating/preparation/MatingPreparationRoute'));
const MatingScheduleRoute = lazy(() => import('./pages/mating/schedule/MatingScheduleRoute'));
const GoatBirthTypeRoute = lazy(() => import('./pages/goat-birth-type/GoatBirthTypeRoute'));
const UserAuthorityRoute = lazy(() => import('./pages/user-authorization/UserAuthorityRoute'));
const Admin = lazy(() => import('./pages/admin/AdminRoute'));
const Certificate = lazy(() => import('./pages/certificate/Certificate'));
const GoatCard = lazy(() => import('./pages/certificate/GoatCard'));
const MatingPreparationRouteV2 = lazy(() => import('./pages/matingV2/preparation/MatingPreparationRouteV2'));
const MatingScheduleRouteV2 = lazy(() => import('./pages/matingV2/schedule/MatingScheduleRouteV2'));
const MatingFinishedRoute = lazy(() => import('./pages/matingV2/finish/MatingFinishedRoute'));
const MatingHistoryRoute = lazy(() => import('./pages/matingV2/history/MatingHistoryRoute'));
const ReportRoute = lazy(() => import('./pages/report/ReportRoute'));

function App() {
    return (
        <BrowserRouter>
            <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }>
                <Switch>
                    <Route exact path={RoutePath.LOGIN} component={Login} />
                    <Route path={RoutePath.DASHBOARD} component={Dashboard} />
                    <Route path={RoutePath.SECTION} component={Section} />
                    <Route path={RoutePath.COUNTRY} component={Country} />
                    <Route path={RoutePath.VENDOR} component={Vendor} />
                    <Route path={RoutePath.COLOR} component={Color} />
                    <Route path={RoutePath.GOAT_PEN} component={GoatPen} />
                    <Route path={RoutePath.GOAT_TYPE} component={GoatType} />
                    <Route path={RoutePath.GRADE} component={Grade} />
                    <Route path={RoutePath.KAMBING} component={KambingRoute} />
                    <Route path={RoutePath.DEAD} component={DeadRoute} />
                    <Route path={RoutePath.SUPPLIER} component={Supplier} />
                    <Route path={RoutePath.OWNER} component={Owner} />
                    <Route path={RoutePath.FEEDING} component={Feeding} />
                    <Route path={RoutePath.FOOD} component={Food} />
                    <Route path={RoutePath.BUNKER} component={Bunker} />
                    <Route path={RoutePath.GOAT_BIRTH_TYPE} component={GoatBirthTypeRoute} />
                    <Route path={RoutePath.MATING_PREPARATION} component={MatingPreparationRoute} />
                    <Route path={RoutePath.MATING_PREPARATIONV2} component={MatingPreparationRouteV2} />
                    <Route path={RoutePath.MATING_SCHEDULE} component={MatingScheduleRoute} />
                    <Route path={RoutePath.MATING_SCHEDULEV2} component={MatingScheduleRouteV2} />
                    <Route path={RoutePath.MATING_FINISHED} component={MatingFinishedRoute} />
                    <Route path={RoutePath.MATING_HISTORY} component={MatingHistoryRoute} />
                    <Route path={RoutePath.MENU_AUTHORIZATION} component={UserAuthorityRoute} />
                    <Route path={RoutePath.CHANGE_PASSWORD} component={ChangePassword} />
                    <Route path={RoutePath.RESET_PASSWORD} component={ResetPassword} />
                    <Route path={RoutePath.CERTIFICATE} component={Certificate} />
                    <Route path={RoutePath.GOAT_CARD} component={GoatCard} />
                    <Route path={RoutePath.QR_LANDING_PAGE} component={LandingPageQR} />
                    <Route path={RoutePath.REPORT} component={ReportRoute} />
                    <Route path={RoutePath.ADMIN} component={Admin} />
                    <Route path={RoutePath.GLOBAL_SETTING} component={GlobalSetting} />
                    <Route path={RoutePath.FAMILY_NAME} component={FamilyName} />
                    <Redirect to={RoutePath.DASHBOARD} />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
